import React from 'react';
import { UploadFile } from 'antd';
import { CustomDocument } from './CustomDocument';
import { StyledCustomUploadList } from './style';

interface CustomUploadListProps {
  fileList: UploadFile[];
  onRemove: (file: UploadFile) => void;
  onDownload?: (file: UploadFile) => void;
  onDelete?: (file: UploadFile) => void;
  showActions?: boolean;
}

export const CustomUploadList: React.FC<CustomUploadListProps> = ({
  fileList,
  onRemove,
  onDownload,
  onDelete,
  showActions = true,
}) => {
  const handleDelete = (file: UploadFile) => {
    if (onDelete) {
      onDelete(file);
    } else {
      onRemove(file);
    }
  };

  return (
    <StyledCustomUploadList>
      {fileList.map((file) => (
        <CustomDocument
          key={file.uid}
          file={file}
          onDownload={onDownload}
          onDelete={handleDelete}
          showActions={showActions}
        />
      ))}
    </StyledCustomUploadList>
  );
};
